import Vue from 'vue'
import { pushPage, navigateBack, jump2filter, jump2housing } from '@zhenguo/jssdk/router'

export default {
  install(app: typeof Vue) {
    app.prototype.$pushPage = pushPage
    app.prototype.$navigateBack = navigateBack
    app.prototype.$jump2filter = jump2filter
    app.prototype.$jump2housing = jump2housing
  },
}
